/**
 * Deduplication helpers for EntityReports — match analysis rows to scheduled analyses
 * so the UI can merge them instead of showing duplicates.
 */

export type DedupRow = {
	id?: string;
	title?: string;
	externalId?: string;
	packId?: string;
	_analysis?: { scheduleId?: string | null; metadata?: { conversation?: { id?: string } } };
};

export type DedupSchedule = {
	id: string;
	conversationId: string;
	packId?: string | null;
	packName: string | null;
};

function normalizeComparisonText(value: string | null | undefined): string {
	return value?.trim().toLowerCase() ?? "";
}

function getRowConversationId(row: DedupRow): string | undefined {
	return row.externalId ?? row._analysis?.metadata?.conversation?.id;
}

export function doesRowMatchSchedule(row: DedupRow, schedule: DedupSchedule): boolean {
	const scheduleName = normalizeComparisonText(schedule.packName);
	const rowTitle = normalizeComparisonText(row.title);
	const rowConversationId = getRowConversationId(row);
	const analysisWithSchedule = row._analysis as { scheduleId?: string | null } | undefined;

	if (analysisWithSchedule?.scheduleId === schedule.id) {
		return true;
	}

	if (row.id === schedule.id) {
		return true;
	}

	if (rowConversationId && rowConversationId !== schedule.conversationId) {
		return false;
	}

	if (row.packId && schedule.packId && row.packId === schedule.packId) {
		return true;
	}

	if (scheduleName && rowTitle && (rowTitle === scheduleName || rowTitle.startsWith(`${scheduleName} -`))) {
		return true;
	}

	return false;
}
